import { createAction, handleActions } from 'redux-actions';
import {
  reorderAndUpdateItemsInArrayByIds,
  replaceObjectInList,
} from '../../utility/helpers';
import http from '../../utility/http';
import { API_DIVISIONS } from '../../constants/apiRoutes';
// ------------------------------------
// Constants
// ------------------------------------

const SET_DIVISIONS_AND_DEPARTMENTS = 'SET_DIVISIONS_AND_DEPARTMENTS';
const SET_DIVISIONS_REORDERING = 'SET_DIVISIONS_REORDERING';
const SET_DEPARTMENTS_REORDERING = 'SET_DEPARTMENTS_REORDERING';

const initialState = {
  departments: [],
  divisions: [],
};

// ------------------------------------
// Actions
// ------------------------------------
const setDivisionsAndDepartments = createAction(SET_DIVISIONS_AND_DEPARTMENTS);
export const setDivisionsReordering = createAction(SET_DIVISIONS_REORDERING);
export const setDepartmentsReordering = createAction(
  SET_DEPARTMENTS_REORDERING
);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_DIVISIONS_AND_DEPARTMENTS]: (state, { payload }) => {
    return {
      ...state,
      departments: payload?.reduce((acc, curr) => {
        return [...acc, ...curr.departments];
      }, []),
      divisions: payload,
    };
  },
  [SET_DIVISIONS_REORDERING]: (state, { payload }) => {
    const { divisions } = state;
    return {
      ...state,
      divisions: reorderAndUpdateItemsInArrayByIds(
        divisions,
        payload.divisionIds
      ),
    };
  },
  [SET_DEPARTMENTS_REORDERING]: (state, { payload }) => {
    const { divisions } = state;
    const { divisionIndex, departmentIds } = payload;

    return {
      ...state,
      divisions: replaceObjectInList(divisions, divisionIndex, {
        ...divisions[divisionIndex],
        departments: reorderAndUpdateItemsInArrayByIds(
          divisions[divisionIndex].departments,
          departmentIds
        ),
      }),
    };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const getDivisionsAndDepartments = dispatch => {
  return http.get(API_DIVISIONS).then(({ data }) => {
    dispatch(setDivisionsAndDepartments(data));
  });
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearDivisionsAndDepartments = () =>
  setDivisionsAndDepartments(initialState.departments);
